import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Plus, Minus, ShoppingBag, ArrowRight, ArrowLeft } from 'lucide-react';
import Header from './components/Header8';
import Footer from './components/Footer8';

const Cart8 = () => {
    const navigate = useNavigate();
    const [showEmpty, setShowEmpty] = useState(false);

    const [cartItems, setCartItems] = useState([
        { id: 1, name: 'Rose Silk Anarkali', price: 7499, quantity: 1, size: 'M', color: 'Blush Rose', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 2, name: 'Designer Banarasi Saree', price: 12999, quantity: 1, size: 'Free Size', color: 'Rose Gold', image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { id: 3, name: 'Festive Palazzo Suit', price: 4999, quantity: 2, size: 'S', color: 'Soft Pink', image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=800' },
    ]);

    const updateQuantity = (id, delta) => {
        setCartItems(items => items.map(item => item.id === id ? { ...item, quantity: Math.max(1, item.quantity + delta) } : item));
    };

    const removeItem = (id) => {
        setCartItems(items => items.filter(item => item.id !== id));
    };

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const shipping = subtotal > 1999 ? 0 : 99;
    const total = subtotal + shipping;
    const isEmpty = showEmpty || cartItems.length === 0;

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');`}</style>
            <div style={{ fontFamily: "'DM Sans', sans-serif" }} className="min-h-screen bg-white">
                <Header cartCount={cartItems.length} />
                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-[1400px] mx-auto">
                        <div className="mb-10">
                            <p className="text-sm tracking-[0.3em] uppercase mb-2 font-medium" style={{ color: '#BE185D' }}>Shopping</p>
                            <h1 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-3xl lg:text-4xl font-bold">Your Bag</h1>
                        </div>

                        {isEmpty ? (
                            <div className="flex flex-col items-center justify-center py-24">
                                <div className="w-24 h-24 rounded-full flex items-center justify-center mb-8" style={{ backgroundColor: '#FDF2F8' }}>
                                    <ShoppingBag className="w-10 h-10" style={{ color: '#F9A8D4' }} />
                                </div>
                                <h2 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-2xl font-bold mb-3">Your bag is empty</h2>
                                <p className="text-sm mb-8 max-w-sm text-center" style={{ color: '#6B7280' }}>Discover our curated collections and find pieces that make you bloom.</p>
                                <button
                                    onClick={() => navigate('/template8/shop')}
                                    className="inline-flex items-center gap-2 px-8 py-3 rounded-lg text-sm font-semibold uppercase tracking-wider transition-all"
                                    style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}
                                >
                                    Start Shopping <ArrowRight size={16} />
                                </button>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                                {/* Cart Items */}
                                <div className="lg:col-span-2 space-y-4">
                                    {cartItems.map((item) => (
                                        <div key={item.id} className="flex gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FDF2F8', border: '1px solid #F9A8D4' }}>
                                            <div className="w-24 h-32 lg:w-28 lg:h-36 rounded-lg overflow-hidden flex-shrink-0">
                                                <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                                            </div>
                                            <div className="flex-1 flex flex-col justify-between">
                                                <div>
                                                    <div className="flex items-start justify-between">
                                                        <div>
                                                            <h3 className="text-sm lg:text-base font-semibold mb-1" style={{ color: '#1A1A1A' }}>{item.name}</h3>
                                                            <p className="text-xs" style={{ color: '#6B7280' }}>Size: {item.size} | Color: {item.color}</p>
                                                        </div>
                                                        <button onClick={() => removeItem(item.id)} className="p-1 rounded-full transition-colors" style={{ color: '#6B7280' }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.color = '#BE185D')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.color = '#6B7280')}
                                                        >
                                                            <X size={18} />
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="flex items-center justify-between mt-3">
                                                    <div className="inline-flex items-center rounded-lg" style={{ border: '1px solid #F9A8D4', backgroundColor: '#FFFFFF' }}>
                                                        <button onClick={() => updateQuantity(item.id, -1)} className="w-8 h-8 flex items-center justify-center" style={{ color: '#BE185D' }}><Minus size={14} /></button>
                                                        <span className="w-8 h-8 flex items-center justify-center text-sm font-medium">{item.quantity}</span>
                                                        <button onClick={() => updateQuantity(item.id, 1)} className="w-8 h-8 flex items-center justify-center" style={{ color: '#BE185D' }}><Plus size={14} /></button>
                                                    </div>
                                                    <span className="text-sm font-bold" style={{ color: '#BE185D' }}>{`\u20B9${(item.price * item.quantity).toLocaleString('en-IN')}`}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <button onClick={() => navigate('/template8/shop')} className="inline-flex items-center gap-2 text-sm font-medium mt-4" style={{ color: '#BE185D' }}>
                                        <ArrowLeft size={16} /> Continue Shopping
                                    </button>
                                </div>

                                {/* Order Summary */}
                                <div>
                                    <div className="p-6 rounded-xl sticky top-24" style={{ backgroundColor: '#FDF2F8', border: '1px solid #F9A8D4' }}>
                                        <h3 className="text-lg font-bold mb-6" style={{ fontFamily: "'Libre Baskerville', serif" }}>Order Summary</h3>
                                        <div className="space-y-3 mb-6">
                                            <div className="flex justify-between text-sm"><span style={{ color: '#6B7280' }}>Subtotal</span><span className="font-medium">{`\u20B9${subtotal.toLocaleString('en-IN')}`}</span></div>
                                            <div className="flex justify-between text-sm"><span style={{ color: '#6B7280' }}>Shipping</span><span className="font-medium" style={{ color: shipping === 0 ? '#16a34a' : '#1A1A1A' }}>{shipping === 0 ? 'FREE' : `\u20B9${shipping}`}</span></div>
                                            <div className="pt-3" style={{ borderTop: '1px solid #F9A8D4' }}>
                                                <div className="flex justify-between"><span className="font-semibold">Total</span><span className="text-lg font-bold" style={{ color: '#BE185D' }}>{`\u20B9${total.toLocaleString('en-IN')}`}</span></div>
                                            </div>
                                        </div>
                                        {shipping > 0 && <p className="text-xs mb-4" style={{ color: '#BE185D' }}>Add {`\u20B9${(1999 - subtotal).toLocaleString('en-IN')}`} more for free shipping</p>}
                                        <button
                                            onClick={() => navigate('/template8/checkout')}
                                            className="w-full py-4 rounded-lg text-sm font-semibold uppercase tracking-wider transition-all flex items-center justify-center gap-2"
                                            style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#9D174D'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#BE185D'; }}
                                        >
                                            Proceed to Checkout <ArrowRight size={16} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Cart8;
